/** @jsx jsx */
import { jsx } from "theme-ui"
import Grid from "../Grid"
import Col from "./Col"

const GridRow = props => (
  <Grid
    sx={{
      gridTemplateColumns: ["repeat(8, 1fr)", "repeat(24, 1fr)"],
    }}
    {...props}
  />
)

GridRow.Col = Col

export default GridRow
